import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/nfse/elserpro/';

class SessoaService {
    constructor() {
        this.idContribuinte = null;
        this.idCliente =null
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type':'application/json',
                'authorization':'Bearer ' + (data ? data.token:'')
            };
        });
    }

    findByDocumento(idCliente, documento) {
        return axios.get(API_URL + 'filterDocSerpro?idCliente='+idCliente+'&documento='+documento, {headers: this.headers});
    }
}

export default new SessoaService();